import { isDefined } from "@clipboard-health/util-ts";
import { z } from "zod";

const destinationSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
});

export const parametersFormSchema = z
  .object({
    destination: destinationSchema.nullable().refine((value) => value !== null, {
      message: "Destination workplace is required",
    }),
    effectiveStarting: z.date({ required_error: "Effective starting date is required" }),
    effectiveEnding: z.date().nullable(),
  })
  .refine(
    (data) =>
      !isDefined(data.effectiveEnding) ||
      data.effectiveEnding.getTime() >= data.effectiveStarting.getTime(),
    {
      path: ["effectiveEnding"],
      message: "Effective ending must be on or after effective starting",
    }
  );

export type ShiftMigrationParametersFormValues = z.input<typeof parametersFormSchema>;

export interface ShiftMigrationParametersSubmitValues {
  destination: { id: string; name: string };
  effectiveStarting: Date;
  effectiveEnding?: Date;
}
